document.addEventListener('turbolinks:load', function() {
  // Fullscreen Button
  $(".fullscreen").on('click', function () {
    iconClass = $(this).find("i").attr("class");
    if (iconClass == "fas fa-expand-arrows-alt") {
      openFullscreen(document.documentElement);
      $(this).html('<i class="fas fa-compress-arrows-alt" data-toggle="tooltip" title="Salir de pantalla completa" data-placement="bottom"></i>');
    } else {
      exitFullscreen();
      $(this).html('<i class="fas fa-expand-arrows-alt" data-toggle="tooltip" title="Pantalla completa" data-placement="bottom"></i>');
    }
  });

  // View in fullscreen
  function openFullscreen(element) {
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) { /* Firefox */
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) { /* IE/Edge */
      element.msRequestFullscreen();
    }
  }

  // Exit fullscreen
  function exitFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) { /* Firefox */
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) { /* IE/Edge */
      document.msExitFullscreen();
    }
  }
});